export const INTERVIEW_STEP_FORM_TYPES = {
    PRE: 'INTERVIEW_REGISTRATION',
    POST: 'POST_INTERVIEW_REGISTRATION',
};
export const INTERVIEW_ROOM_PROVIDERS = ['INTERVIEW_ROOM', 'INTERVIEW_ROOMS'];
